import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import esModals from "./locales/es/modals";
import esDialogs from "./locales/es/dialogs";
import esCommon from "./locales/es/common";
import esPages from "./locales/es/pages";
import esMisc from "./locales/es/misc";
import esDates from "./locales/es/dates";
import esInfoBlocks from "./locales/es/info-blocks";
import esInputs from "./locales/es/inputs";
import esCtas from "./locales/es/ctas";
import esExtensions from "./locales/es/extensions";

import enModals from "./locales/en/modals";
import enDialogs from "./locales/en/dialogs";
import enCommon from "./locales/en/common";
import enPages from "./locales/en/pages";
import enMisc from "./locales/en/misc";
import enDates from "./locales/en/dates";
import enInfoBlocks from "./locales/en/info-blocks";
import enInputs from "./locales/en/inputs";
import enCtas from "./locales/en/ctas";
import enExtensions from "./locales/en/extensions";

import ptModals from "./locales/pt/modals";
import ptDialogs from "./locales/pt/dialogs";
import ptCommon from "./locales/pt/common";
import ptPages from "./locales/pt/pages";
import ptMisc from "./locales/pt/misc";
import ptDates from "./locales/pt/dates";
import ptInfoBlocks from "./locales/pt/info-blocks";
import ptInputs from "./locales/pt/inputs";
import ptCtas from "./locales/pt/ctas";
import ptExtensions from "./locales/pt/extensions";

import zhModals from "./locales/zh/modals";
import zhDialogs from "./locales/zh/dialogs";
import zhCommon from "./locales/zh/common";
import zhPages from "./locales/zh/pages";
import zhMisc from "./locales/zh/misc";
import zhDates from "./locales/zh/dates";
import zhInfoBlocks from "./locales/zh/info-blocks";
import zhInputs from "./locales/zh/inputs";
import zhCtas from "./locales/zh/ctas";
import zhExtensions from "./locales/zh/extensions";

import hiModals from "./locales/hi/modals";
import hiDialogs from "./locales/hi/dialogs";
import hiCommon from "./locales/hi/common";
import hiPages from "./locales/hi/pages";
import hiMisc from "./locales/hi/misc";
import hiDates from "./locales/hi/dates";
import hiInfoBlocks from "./locales/hi/info-blocks";
import hiInputs from "./locales/hi/inputs";
import hiCtas from "./locales/hi/ctas";
import hiExtensions from "./locales/hi/extensions";

import { DEFAULT_LANGUAGE } from "./helpers/constants";

i18n

  // if you want your translations to be loaded from a professional CDN

  // .use(Backend)

  // to detect user language

  .use(LanguageDetector)

  // to pass the i18n instance to react-i18next.

  .use(initReactI18next)

  // init i18next

  .init({
    resources: {
      es: {
        modals: esModals,
        dialogs: esDialogs,
        common: esCommon,
        pages: esPages,
        misc: esMisc,
        dates: esDates,
        info_blocks: esInfoBlocks,
        inputs: esInputs,
        ctas: esCtas,
        extensions: esExtensions,
      },
      en: {
        modals: enModals,
        dialogs: enDialogs,
        common: enCommon,
        pages: enPages,
        misc: enMisc,
        dates: enDates,
        info_blocks: enInfoBlocks,
        inputs: enInputs,
        ctas: enCtas,
        extensions: enExtensions,
      },
      pt: {
        modals: ptModals,
        dialogs: ptDialogs,
        common: ptCommon,
        pages: ptPages,
        misc: ptMisc,
        dates: ptDates,
        info_blocks: ptInfoBlocks,
        inputs: ptInputs,
        ctas: ptCtas,
        extensions: ptExtensions,
      },
      zh: {
        modals: zhModals,
        dialogs: zhDialogs,
        common: zhCommon,
        pages: zhPages,
        misc: zhMisc,
        dates: zhDates,
        info_blocks: zhInfoBlocks,
        inputs: zhInputs,
        ctas: zhCtas,
        extensions: zhExtensions,
      },
      hi: {
        modals: hiModals,
        dialogs: hiDialogs,
        common: hiCommon,
        pages: hiPages,
        misc: hiMisc,
        dates: hiDates,
        info_blocks: hiInfoBlocks,
        inputs: hiInputs,
        ctas: hiCtas,
        extensions: hiExtensions,
      },
    },
    fallbackLng: DEFAULT_LANGUAGE,
    debug: false,
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
  });

export default i18n;
